import { useEffect, useRef } from "react";

// Autosave a form object to localStorage under a stable key.
// Debounced so we don't hammer localStorage on every keystroke.
export function useDraftAutosave(key, value, { enabled = true, delay = 400 } = {}) {
  const timerRef = useRef(null);
  useEffect(() => {
    if (!enabled || !key) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      try {
        localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), value }));
      } catch (_) {}
    }, delay);
    return () => timerRef.current && clearTimeout(timerRef.current);
  }, [key, value, enabled, delay]);
}

export function readDraft(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed; // { savedAt, value }
  } catch (_) {
    return null;
  }
}

export function clearDraft(key) {
  try { localStorage.removeItem(key); } catch (_) {}
}

// Human-friendly time ago string, e.g. "2 min ago"
export function timeAgo(ms) {
  if (!ms) return "";
  const diff = Math.max(0, Date.now() - ms);
  const s = Math.floor(diff / 1000);
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
